<div *ngIf="findByAttributeService">
    <app-loading [loading]="!hideLoading && loading" [text]="loadingText"></app-loading>
    <app-error-card *ngIf="error" [error]="error"></app-error-card>
    <app-error-card *ngIf="notFound && !ignoreNotFoundError"
                    message="Votre demande n'a pu être trouvée"></app-error-card>
    <div [style]="loading || error || (notFound && !ignoreNotFoundError)? 'display: none;' : ''">
        <ng-content></ng-content>
    </div>
</div>
